import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  API_URL_CONSULTATION,
  API_URL_CONSULTATION_ADD,
  API_URL_SEARCH_CONSULTATION,
} from 'manager/http-constants';
import { CONSULTATION_M701_TEMPLATE } from 'manager/template-constant';


import { GenerateDisplayComponent } from 'src/app/shared/generate/generate-display/generate-display.component';
import { GenerateInputComponent } from 'src/app/shared/generate/generate-input/generate-input.component';
import { DeleteDialogComponent } from 'src/app/shared/html-parts/delete-dialog/delete-dialog.component';
import {
  LoadData,
  LoadingState,
} from 'src/app/shared/html-parts/loading/loading-state';
import { CommonService } from 'src/app/shared/service/common.service';
import { DbOperationService } from 'src/app/shared/service/db-operation.service';
import { CONSULTATION_CONSTANT } from './constant';
import { LoginService } from 'src/app/shared/service/login.service';
import { CHATSTATUSES, CONSTANT, CONSULT_STATUS, CONSULT_STATUS_JSON, LOADING_KEY } from 'src/app/shared/constant/constant';
import { ConfirmationService, MessageService } from 'primeng/api';
import { MessageData, ToastMessageData } from 'src/app/shared/html-parts/message-common/message-data';
import { MESSAGE_CODE } from 'src/app/shared/constant/message-constant';
import { TOAST } from 'src/app/shared/constant/primeng-constants';
import { ConsultationDialogComponent } from '../../common/consultation-dialog/consultation-dialog.component';

@Component({
  selector: 'app-m701',
  templateUrl: '../master.component.html',
  styleUrls: ['../master.component.scss', '../../platform.component.scss'],
})
export class M701Component implements OnInit {

  /** 詳細画面 */
  @ViewChild(GenerateDisplayComponent)
  generateDisplayItemsComponent: GenerateDisplayComponent;

  /** 新規登録、編集、複製画面 */
  @ViewChild(GenerateInputComponent)
  generateInputComponent: GenerateInputComponent;

  /** 削除ダイアログ */
  @ViewChild(DeleteDialogComponent)
  deleteDialogComponent: DeleteDialogComponent;

  @ViewChild(ConsultationDialogComponent)
  consultationDialogComponent: ConsultationDialogComponent;

  classId: any;

  // 検索項目生成エンドポイント
  public searchEndPoint: string = API_URL_SEARCH_CONSULTATION;

  // 検索項目生成テンプレートID
  public searchTemplateId: number = CONSULTATION_M701_TEMPLATE.SEARCH_TEMPLATE_ID;

  /* 画面用プロパティ */
  // 画面ヘッダー情報格納先
  columnOrder: any[] = new Array();

  // 画面検索結果一覧格納先
  searchResultsList: any[] = new Array();
  searchResultsListOld: any[] = new Array();

  // 検索条件保持
  generateSearchItems: Object;

  // set first page = 1 
  pages: number = 0;
  title: any = "";
  showLinkPDF: boolean = false;
  linkPDF = '';
  m701 = true
  innerWidth: any;
  checkMobile: boolean = false;
  isShowSearchMobile: boolean = false;
  isScroll: boolean = false;
  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    public datePipe: DatePipe,
    private loginService: LoginService,
    private changeDetector: ChangeDetectorRef,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private messageData: MessageData
  ) {
    //      super(route, commonService, dbOperationService, loadingState, loginService);

  }

  async ngOnInit(): Promise<void> {
    this.innerWidth = window.innerWidth;
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart();
    await this.loginService.checkLoginUser();
    this.classId = this.loginService.getCurrentUser().class_id;
    /* ヘッダー情報取得処理(画面用) */
    this.dbOperationService
      .getHeaderList(CONSULTATION_M701_TEMPLATE.SEARCH_RESULTS_TEMPLATE_ID)
      .subscribe((response) => {
        if ((this.innerWidth > 450 && window.screen.orientation.type == 'portrait-primary') || (window.innerHeight > 450 && window.screen.orientation.type == 'landscape-primary')) {
          this.columnOrder = response.body
        }
        else {
          this.columnOrder = response.body.slice(0, 4);
          this.columnOrder = response.body.filter((item) => ["consultation_consultation_id", "consultation_consult_status", "consultation_detail", "consultation_message"].includes(item.field));
          // let temp = this.columnOrder.pop()
          // this.columnOrder.unshift(temp)
          this.checkMobile = true
        }
      });

    // 検索処理を実施
    this.searchResult();
  }

  /**
   * 検索処理
   * @param generateSearchItems 検索条件
   */
  public searchResult(generateSearchItems?: Object) {
    // 画面カスタムロードフラグをON(ロード中状態)
    this.loadingState.loadStart(API_URL_CONSULTATION);

    // CSV出力用に検索条件を保持
    this.generateSearchItems = generateSearchItems;

    /* 課題・ソリューション一覧取得処理(画面用) */
    this.dbOperationService
      .getForkJoinData(
        CONSULTATION_CONSTANT.TABLE,
        API_URL_CONSULTATION,
        CONSULTATION_M701_TEMPLATE.SEARCH_RESULTS_TEMPLATE_ID,
        generateSearchItems,
        true
      )
      .subscribe((response) => {
        // コード値の一覧情報が存在するか否か
        if (!this.commonService.checkNoneResponse(response)) {
          // 課題・ソリューション一覧情報のJSONをオブジェクトに格納する
          this.searchResultsList = response.body;
          this.searchResultsList.forEach((item) => {
            item.consultation_consultation_id = Number(item.consultation_consultation_id)
          })
        } else {
          this.searchResultsList = new Array();
        }
        this.searchResultsListOld = JSON.parse(JSON.stringify(this.searchResultsList));
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, API_URL_CONSULTATION);
        //return to first page
        this.pages = 0;
      });


  }

  /**
  * check overflow of element
  * @param el html element of list 
  * @returns 
  */
  isOverflow(el: HTMLElement): boolean {
    const curOverflow = el.style.overflow;
    if (!curOverflow || curOverflow === "visible")
      el.style.overflow = "hidden";
    const isOverflowing = el.clientWidth < el.scrollWidth
      || el.clientHeight < el.scrollHeight;
    el.style.overflow = curOverflow;
    return isOverflowing;
  }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  /**
   * プライマリーカラムを取得
   */
  protected getPkeyColumn(): string {
    return this.commonService.getPkeyColumn(this.columnOrder);
  }

  public setClassStatusDropdown(matchStatus) {
    let classActiveColor = CONSTANT.EMPTY_STRING;
    switch (matchStatus) {
      case CONSULT_STATUS.NOT_YET_RESOLVED.code:
        classActiveColor = "gray-dropdown-color";
        break;
      case CONSULT_STATUS.INPROGRESS.code:
        classActiveColor = "yellow-dropdown-color";
        break;
      case CONSULT_STATUS.RESOLVED.code:
        classActiveColor = "blue-dropdown-color";
        break;
      default:
        break;
    }
    return classActiveColor;
  }

  getListStatusChange(status: any, type: any) {
    return [CONSULT_STATUS.NOT_YET_RESOLVED, CONSULT_STATUS.INPROGRESS, CONSULT_STATUS.RESOLVED]
  }

  public changeStatus(event, consultation_id) {
    this.confirmationService.confirm({
      message: this.commonService.msg(MESSAGE_CODE.D00012, CONSULT_STATUS_JSON[event.value]),
      header: CONSTANT.EMPTY_ONE_STRING,
      icon: "pi pi-info-circle",
      accept: () => {
        // 画面カスタムロードフラグをON(ロード中状態)
        this.loadingState.customLoadStart(
          new LoadData({
            loadingText: CONSTANT.EMPTY_STRING,
            background_color: CONSTANT.EMPTY_STRING,
            opacity: 0.3,
          }),
          LOADING_KEY.DATA_UPDATE
        );

        this.dbOperationService
          .updateData(API_URL_CONSULTATION_ADD, consultation_id, { consult_status: event.value })
          .subscribe((response) => {
            // APIレスポンスの判定
            if (this.commonService.checkInvalidValue(response)) {
              // 警告メッセージ
              this.messageData.toastMessage(
                new ToastMessageData({
                  severity: TOAST.WARN,
                  summary: this.commonService.msg(MESSAGE_CODE.E00003),
                  detail: this.commonService.msg(MESSAGE_CODE.E00026),
                })
              );
            } else if (this.commonService.checkRunningNormallyResponse(response)) {
              // 正常メッセージ
              this.messageService.add({
                severity: TOAST.SUCCESS,
                summary: this.commonService.msg(MESSAGE_CODE.T00002),
              });
            } else {
              // APIが異常終了の場合

              // 異常メッセージ
              this.messageService.add({
                severity: TOAST.ERROR,
                summary: this.commonService.msg(MESSAGE_CODE.E00002),
                detail: this.commonService.msg(MESSAGE_CODE.E00006),
              });
            }
            // 画面ロードフラグをOFF(ロード終了)
            this.loadingState.loadEnd(LOADING_KEY.DATA_UPDATE);

            // 親画面に更新対象IDを設定
          });
      },
      reject: () => {
        const i = this.searchResultsList.findIndex(item => item.consultation_consultation_id == consultation_id)
        this.searchResultsList[i].consultation_consult_status = this.searchResultsListOld[i].consultation_consult_status
      },
    });
  }

  /**
   * 再検索処理＆データ置換
   * @param pkeyId コード値
   */
  public searchReplacement(pkeyId: string) {
    // 画面カスタムロードフラグをON(ロード中状態)
    this.loadingState.loadStart(API_URL_CONSULTATION);


    // 返却されたコード値が存在するか否か
    if (null == pkeyId || undefined == pkeyId) {
      // 返却されたコード値が存在しない場合

      // 検索処理を実施
      this.searchResult();

      return;
    }
    const colId = this.checkMobile ? 1 : 0;
    // 営業日マスタ一覧取得処理(画面用)
    this.dbOperationService
      .getSingleData(
        API_URL_CONSULTATION,
        CONSULTATION_M701_TEMPLATE.SEARCH_RESULTS_TEMPLATE_ID,
        this.columnOrder[colId].field,
        pkeyId
      )
      .subscribe((response) => {

        // コード値の一覧情報が存在するか否か
        if (this.commonService.checkNoneResponse(response)) {
          // 一覧情報が存在しない場合

          // 検索結果一覧から該当データを削除
          this.searchResultsList = this.searchResultsList.filter(
            (val) => val[this.columnOrder[colId].field] !== pkeyId
          );
          this.searchResultsList.forEach((item) => {
            item.consultation_consultation_id = Number(item.consultation_consultation_id)
          })
          this.searchResultsListOld = JSON.parse(JSON.stringify(this.searchResultsList));

          // 画面ロードフラグをOFF(ロード終了)
          this.loadingState.loadSleepEnd(0.3, API_URL_CONSULTATION);
        } else {
          // 一覧情報が存在する場合

          // 検索結果一覧格納先から対象のデータの行数を抽出
          const indexTargetData = this.searchResultsList.indexOf(
            this.searchResultsList.find((results) => {
              return results[this.columnOrder[colId].field] === pkeyId;
            })
          );

          // 検索結果一覧情報のJSONをオブジェクトに置換する
          this.searchResultsList.splice(indexTargetData, 1, response.body[0]);
          this.searchResultsList.forEach((item) => {
            item.consultation_consultation_id = Number(item.consultation_consultation_id)
          })
          this.searchResultsListOld = JSON.parse(JSON.stringify(this.searchResultsList));

          // 画面ロードフラグをOFF(ロード終了)
          this.loadingState.loadSleepEnd(0.3, API_URL_CONSULTATION);
        }
      });
  }

  openURI() {
    window.open(this.linkPDF, '_blank').focus();
  }
  detailM701(consultation_contente) {
    this.consultationDialogComponent.openConsultationDialog("", { contente: consultation_contente, type: "detail_c502" });
  }
  closeConsultationDialog(openDialog: boolean): void { }

  moveC601(item) {
    this.router.navigate(["pages/platform/c601", item.consultation_match_id]);
  }
  addScroll(event: any) {
    console.log(event);
    this.isScroll = event
  }
}
